import React from 'react';
import { connect } from 'react-redux';
import { Widget } from '@spins/react-ui-library';
import Highlights from 'components/Highlights';
import { HighlightValueFormat } from 'components/Highlight';
import HighlightQuery from 'components/HighlightQuery';
import { DISTRIBUTION_VOID_KPI, POD_KPI, SALES_KPI, UNITS_KPI } from 'apollo/queries';
import { GetCampaignDocument as getCampaignQuery } from 'generated/campaigns-graphql';
import { GlobalFilterType } from 'utils/types';
import { campaignsClient } from 'apollo';
import QueryRetryWrapper from 'components/QueryRetryWrapper';
import {
  clientIdSelector,
  currentBrandSelector,
  isEnterpriseContextSelector
} from 'store/global/selectors';
import * as selectors from 'containers/Campaigns/selectors';
import * as pageHeaderSelectors from 'containers/PageHeader/selectors';
import './styles.scss';

interface Props {
  clientId: string;
  currentBrand: string;
  currentWeeks: number;
  endWeek: string;
  selectedCampaign: string;
  isEnterpriseContext: boolean;
}

const CampaignsKPIWidget: React.FC<Props> = ({
  clientId,
  currentBrand,
  currentWeeks,
  endWeek,
  selectedCampaign,
  isEnterpriseContext
}) => {
  const baseFilter = {
    weeks: currentWeeks,
    endWeek: endWeek,
    ...(isEnterpriseContext && { brand: currentBrand }),
    accounts: [],
    stores: [],
    states: [],
    items: []
  };

  return (
    <div className="campaigns-kpi-widget">
      <Widget>
        {{
          header: {
            title: 'Campaigns'
          },
          body: {
            content: (
              <QueryRetryWrapper
                query={getCampaignQuery}
                client={campaignsClient as any}
                variables={{
                  clientID: clientId,
                  id: selectedCampaign
                }}
                fetchPolicy="cache-first"
              >
                {({ data }) => {
                  const campaign = data.retrieve;
                  const filter: GlobalFilterType = {
                    ...baseFilter,
                    accounts: campaign.storeFilters.accounts,
                    stores: campaign.storeFilters.stores,
                    states: campaign.storeFilters.states,
                    items: campaign.itemFilters.items
                  };
                  return (
                    <Highlights>
                      {[
                        <HighlightQuery
                          clientID={clientId}
                          globalFilter={filter}
                          labels={['TOTAL SALES']}
                          query={SALES_KPI}
                          valueFormat={HighlightValueFormat.NUMBER}
                        />,
                        <HighlightQuery
                          clientID={clientId}
                          globalFilter={filter}
                          labels={['UNITS']}
                          query={UNITS_KPI}
                          valueFormat={HighlightValueFormat.NUMBER}
                        />,
                        <HighlightQuery
                          clientID={clientId}
                          globalFilter={filter}
                          labels={['POD']}
                          query={POD_KPI}
                          valueFormat={HighlightValueFormat.NUMBER}
                        />,
                        <HighlightQuery
                          clientID={clientId}
                          globalFilter={filter}
                          labels={['DISTRIBUTION VOIDS']}
                          query={DISTRIBUTION_VOID_KPI}
                          valueFormat={HighlightValueFormat.NUMBER}
                        />
                      ].map((component, index) => React.cloneElement(component, { key: index }))}
                    </Highlights>
                  );
                }}
              </QueryRetryWrapper>
            )
          }
        }}
      </Widget>
    </div>
  );
};

const mapStateToProps = state => ({
  clientId: clientIdSelector(state),
  currentBrand: currentBrandSelector(state),
  currentWeeks: pageHeaderSelectors.globalFilterWeeksSelector(state),
  endWeek: selectors.endWeekSelector(state),
  selectedCampaign: selectors.selectedCampaignSelector(state),
  isEnterpriseContext: isEnterpriseContextSelector(state)
});

export default connect(mapStateToProps)(CampaignsKPIWidget);
